import { configureStore } from '@reduxjs/toolkit'
import { persistReducer, persistStore } from 'redux-persist'
import storage from 'redux-persist/lib/storage'
import { thunk } from 'redux-thunk'
import autoMergeLevel2 from 'redux-persist/lib/stateReconciler/autoMergeLevel2'
import { rootReducers } from './root-reducers'

const persistConfig = {
  key: 'root',
  /* Using LocalStorage to store persisted state */
  storage,
  /* Specify how many levels deep to persist the redux state */
  stateReconciler: autoMergeLevel2,
  version: 1,
}

const persistedReducer = persistReducer(persistConfig, rootReducers)

const store = configureStore({
  reducer: persistedReducer,
  /* Prevents users from access to redux in production */
  devTools: import.meta.env.VITE_ENV !== 'production',
  /* Prevents serializable values from
     poluting slice objects in Redux */
  middleware: [thunk],
})

const persistor = persistStore(store)

/* Clear persisted data in local storage */
function purgePersistedState() {
  persistor.pause()
  persistor.flush().then(() => {
    return persistor.purge()
  })
}

export { store, persistor, purgePersistedState }
